import { data } from 'jquery';
import { TOUR, CURRENCY, DATE_TIME_FORMAT } from '../constants/Define';
import { getMomentDate } from '../utils/commonUtils';
import BaseModel from './BaseModel';
import ObjectType from './ObjectType';
import Property from './Property';
import _ from 'lodash';
export default class Tour extends BaseModel {

    constructor(data = {}) {
        super(data)
        this.setData(data);
    }

    setData(data = this.__data__) {
        this.id = data.id !== undefined ? data.id : undefined;
        this.hasDetail = !!data.tourDetail;
        this.tourName = this.translate.tourName || (this.hasDetail ? data.tourDetail.tourName : data.tourName || undefined);
        this.tourCode = this.hasDetail ? data.tourDetail.tourCode : data.tourCode || undefined;
        this.setDeparture(data);
        this.setDestination(data);
        this.setTourType(data);
        this.airline = this.translate.tourDetail_Airline || (this.hasDetail ? data.tourDetail.airline : data.airline || undefined);
        this.setHotel(data);
        this.adultOriginalPrice = data.adultOriginalPrice || 0;
        this.adultSalePrice = data.adultSalePrice || 0;
        this.childOriginalPrice = data.childOriginalPrice || 0;
        this.childSalePrice = data.childSalePrice || 0;
        this.lengthOfTour = this.hasDetail ? data.tourDetail.lengthOfTour : data.lengthOfTour;
        this.urlSlug = data.urlSlug || undefined;
        this.imageUrlSlug = data.imageUrlSlug || undefined;
        this.setThumbImage(data);
        this.isSpecial = data.isSpecial != null ? data.isSpecial : false;
        this.highlight = this.translate.highlight || (this.hasDetail ? data.tourDetail.highlight : (data.highlight || undefined));
        this.setTripItinerary(data.tourDetail || {});
        this.setServiceIncluded(data.tourDetail || {});
        this.setServiceExcluded(data.tourDetail || {});
        this.setNote(data.tourDetail || {});
        this.setChecklist(data.tourDetail || {});
        // this.extraInfos = this.translate.extraInfos || (this.hasDetail ? data.tourDetail.extraInfos : data.extraInfos || undefined);
        this.extraInfos = this?.translate?.extraInfos || this.initExtraInfos();
        this.type = this.translate.type || (this.hasDetail ? data.tourDetail.type : data.type || undefined);
        this.cancellationPolicy = this.translate.cancellationPolicy || (this.hasDetail ? data.tourDetail.cancellationPolicy : data.cancellationPolicy || undefined);
        this.operationManuals = this.translate.operationManuals || (this.hasDetail ? data.tourDetail.operationManuals : data.operationManuals || undefined);
        this.description = this.translate.description || (this.hasDetail ? data.tourDetail.description : data.description || undefined);
        this.shortDescription = this.translate.shortDescription || (this.hasDetail ? data.tourDetail.shortDescription : data.shortDescription || undefined);
        this.groupSize = this.translate.groupSize || (this.hasDetail ? data.tourDetail.groupSize : data.groupSize || undefined);
        this.tourOperationType = data.tourOperationType || TOUR.OPERATION_TYPE.INBOUND;
        // this.publishDateTime = this.getDate(data.publishDateTime);
        // this.endPublishDateTime = this.getDate(data.endPublishDateTime);
        this.isEnabled = data.isEnabled != null ? data.isEnabled : true;
        this.isHotTour = data.isHotTour != null ? data.isHotTour : false;
        this.isWebsitePublished = data.isWebsitePublished != null ? data.isWebsitePublished : true;
        this.isCrossSell = data.isCrossSell != null ? data.isCrossSell : false;
        this.setSpecialImage(data)
        this.setSlideShowImages(data);
        this.vehicleId = data.vehicleId || undefined;
        this.accommodationId = data.accommodationId || undefined;
        this.activityId = data.activityId || undefined;
        this.mealId = data.mealId || undefined;
        this.saleStartDate = this.getDate(data.saleStartDate);
        this.saleEndDate = this.getDate(data.saleEndDate);
        this.stayStartDate = this.getDate(data.stayStartDate);
        this.stayEndDate = this.getDate(data.stayEndDate);
        this.effectiveStartDate = this.getDate(data.effectiveStartDate);
        this.effectiveEndDate = this.getDate(data.effectiveEndDate);
        this.voucherBookingPeriod = this.getDate(data.voucherBookingPeriod);
        this.cutOffDate = data.cutOffDate || 0;
        this.bookingPeriod = data.bookingPeriod || 0;
        this.order = data.order || 0;
        this.properties = (data.properties || []).map(item => item.id);
        this.tag = this.translate.tag || (this.hasDetail ? data.tourDetail.tag : data.tag || undefined);
        this.productTypes = data.productTypes || [];
        this.installmentFee = data.installmentFee;
        this.installmentLimit = data.installmentLimit;
        this.isLocked = data.isLocked || false;
        this.type = this.translate.type || (this.hasDetail ? data.tourDetail.type : data.type || undefined);
        this.memberShipTypes = data.memberShipTypes || [];
        this.objectType = (data.memberShipTypes && data.memberShipTypes.length > 0) ? 'MEMBER' : 'ALL';
        this.createdDate = this.getDate(data.createdDate);
        this.supplierId = this.hasDetail ? data.tourDetail.supplierId : ''
        this.siteCode = this.hasDetail ? data.tourDetail.siteCode : '';
        this.channel = data.channel || [];
        this.showTicketInfo = data.showTicketInfo || [];
        this.eventZone = data.eventZone !== undefined ? data.eventZone : (this.hasDetail ? data.tourDetail.eventZone : undefined);
    }

    initExtraInfos() {
        return [
            { title: 'Mô tả', content: '' },
            { title: 'Bao gồm', content: '' },
            { title: 'Điều khoản', content: '' },
            { title: 'Chính sách hoàn huỷ', content: '' },
            { title: 'Hướng dẫn sử dụng', content: '' }
        ]
    }

    setTourType(data = {}) {
        this.tourTypes = (data.tourTypes || []).map(type => new TourType(type));
    }

    setDeparture(data = {}) {
        this.departure = data.departure;
        if (!this.departure && data.departureId) {
            this.departure = { id: data.departureId, name: data.departureName }
        }
    }

    setDestination(data = {}) {
        this.destination = data.destination;
        if (!this.destination && data.destinationId) {
            this.destination = { id: data.destinationId, name: data.destinationName }
        }
    }

    setHotel(data = {}) {
        this.hotel = this.hasDetail
            ? { rating: data.tourDetail.hotelRating }
            : (data.hotelRating || data.hotel ? { rating: Number(data.hotelRating || data.hotel) } : undefined)
    }

    setThumbImage(data = {}) {
        // this.thumbImage = data.thumbImageView && new TourImage(data.thumbImageView)
        // this.thumbImage = typeof this.translate.thumbImage === 'string' ? this.translate.thumbImage
        // : (data.thumbImageView && new TourImage(data.thumbImageView));
        this.thumbImage = this.translate.thumbImage ? new TourImage(this.translate.thumbImageView) : undefined
    }

    setTripItinerary(data = {}) {
        const tripItinerary = this.translate.tripItinerary || data.tripItinerary
        this.tripItinerary = (tripItinerary || []).map(item => new TripItinerary(item));
    }

    setServiceIncluded(data = {}) {
        this.serviceIncluded = this.translate.serviceIncluded || data.serviceIncluded || []; // array of string
    }

    setServiceExcluded(data = {}) {
        this.serviceExcluded = this.translate.serviceExcluded || data.serviceExcluded || []; // array of string
    }

    setNote(data) {
        this.note = this.translate.note || data.note || []; // array of string
    }

    setChecklist(data = {}) {
        this.checklist = this.translate.checklist || (data.checklist || []).map(item => new TourChecklist(item));
    }
    setSpecialImage(data = {}) {
        this.specialImage = this.translate.specialImage ? new TourImage(this.translate.specialImageView) : undefined;
    }

    setSlideShowImages(data = {}) {
        // this.slideShowImages = Array.isArray(this.translate.slideShowImages) ? this.translate.slideShowImages
        //     : (data.slideShowImagesView ? (data.slideShowImagesView || []).map(item => new TourImage(item)) : []);
        this.slideShowImages = this.translate.slideShowImagesView && this.translate.slideShowImagesView.length > 0 ? this.translate.slideShowImagesView.map(item => new TourImage(item)) : []
    }

    getDate(dateString) {
        return getMomentDate(dateString)
    }
    // Export to json object to put to API
    export(hasTranslate = false) {
        const result = super.export({
            id: this.id,
            tourTypeIds: this.tourTypes && this.tourTypes.map(item => item.id),
            thumbImage: this.thumbImage && this.thumbImage.name,
            specialImage: this.specialImage && this.specialImage.name,
            slideShowImages: this.slideShowImages && this.slideShowImages.map(item => item.name),
            tourDetail: {
                tourName: this.tourName && this.tourName.trimLeft(),
                tourCode: this.tourCode,
                lengthOfTour: this.lengthOfTour || '0',
                extraInfos: this.extraInfos,
                // highlight: this.highlight && this.highlight.trimLeft(),
                tripItinerary: this.tripItinerary && this.tripItinerary.map(item => item.export()),
                serviceIncluded: this.serviceIncluded && this.serviceIncluded.map(item => item && item.trimLeft()),
                serviceExcluded: this.serviceExcluded && this.serviceExcluded.map(item => item && item.trimLeft()),
                note: this.note && this.note.map(item => item && item.trimLeft()),
                checklist: this.checklist && this.checklist.map(item => item.export()),
                cancellationPolicy: this.cancellationPolicy && this.cancellationPolicy.trimLeft(),
                operationManuals: this.operationManuals && this.operationManuals.trimLeft(),
                // description: this.description && this.description.trimLeft(),
                shortDescription: this.shortDescription && this.shortDescription.trimLeft(),
                groupSize: this.groupSize,
                hotelRating: this.hotel && this.hotel.rating,
                airline: this.airline && this.airline.trimLeft(),
                tag: this.tag,
                type: this.type
            },
            adultOriginalPrice: this.adultOriginalPrice,
            adultSalePrice: this.adultSalePrice,
            childOriginalPrice: this.childOriginalPrice,
            childSalePrice: this.childSalePrice,
            tourOperationType: this.tourOperationType,
            departureId: this.departure && this.departure.id,
            destinationId: this.destination && this.destination.id,
            urlSlug: this.urlSlug,
            imageUrlSlug: this.imageUrlSlug,
            // publishDateTime: this.publishDateTime && this.publishDateTime.toISOString(),
            // endPublishDateTime: this.endPublishDateTime && this.endPublishDateTime.toISOString(),
            isHotTour: this.isHotTour,
            isSpecial: this.isSpecial,
            isEnabled: this.isEnabled,
            isWebsitePublished: this.isWebsitePublished,
            vehicleId: this.vehicleId,
            accommodationId: this.accommodationId,
            activityId: this.activityId,
            mealId: this.mealId,
            saleStartDate: this.saleStartDate && this.saleStartDate.toISOString(),
            saleEndDate: this.saleEndDate && this.saleEndDate.toISOString(),
            stayStartDate: this.stayStartDate && this.stayStartDate.toISOString(),
            stayEndDate: this.stayEndDate && this.stayEndDate.toISOString(),
            effectiveStartDate: this.effectiveStartDate && this.effectiveStartDate.toISOString(),
            effectiveEndDate: this.effectiveEndDate && this.effectiveEndDate.toISOString(),
            voucherBookingPeriod: this.type === 1 ? this.voucherBookingPeriod && this.voucherBookingPeriod.toISOString() : undefined,
            cutOffDate: this.cutOffDate,
            bookingPeriod: this.bookingPeriod,
            order: this.order,
            propertyIds: this.properties,
            productTypes: this.productTypes,
            installmentFee: this.installmentFee,
            installmentLimit: this.installmentLimit,
            memberShipTypes: this.memberShipTypes,
            supplierId: this.supplierId,
            channel: this.channel,
            isCrossSell: this.isCrossSell,
            showTicketInfo: this.showTicketInfo,
            eventZone: this.eventZone
        });
        if (hasTranslate) result.translate = () => {
            return {
                id: this.translate.id,
                tourId: this.translate.tourId || this.id,
                tourName: this.tourName && this.tourName.trimLeft(),
                extraInfos: this.extraInfos,
                tripItinerary: this.tripItinerary && this.tripItinerary.map(item => item.export()),
                serviceIncluded: this.serviceIncluded && this.serviceIncluded.map(item => item && item.trimLeft()),
                serviceExcluded: this.serviceExcluded && this.serviceExcluded.map(item => item && item.trimLeft()),
                note: this.note && this.note.map(item => item && item.trimLeft()),
                // checklist: this.checklist && this.checklist.map(item => item.export()),
                // highlight: this.highlight && this.highlight.trimLeft(),
                cancellationPolicy: this.cancellationPolicy && this.cancellationPolicy.trimLeft(),
                operationManuals: this.operationManuals && this.operationManuals.trimLeft(),
                // extraInfos: this.extraInfos && this.extraInfos.trimLeft(),
                // groupSize: this.groupSize,
                // tourDetail_Airline: this.airline && this.airline.trimLeft(),
                // description: this.description,
                shortDescription: this.shortDescription,
                thumbImage: this.thumbImage && this.thumbImage.name,
                specialImage: this.specialImage && this.specialImage.name,
                slideShowImages: this.slideShowImages && this.slideShowImages.map(item => item.name),
                languageCode: this.languageCode,
                tag: this.tag
            }
        }
        return result;
    }
}

export class TourType {
    constructor(data = {}) {
        this.id = data.id || undefined;
        this.name = data.name || undefined;
    }

    export() {
        return {
            id: this.id,
            name: this.name,
        }
    }
}

export class TagSKUVWTYPE {
    constructor(data = {}) {
        this.id = data.id || undefined;
        this.name =data.name || undefined;
        this.details = data.translations || [];
    }

    export() {
        return {
            id: this.id,
            name: this.name,
        }
    }
}

export class TourSurchargeCategories {
    constructor(data = {}) {
        this.id = data.id || undefined;
        this.name = data.name || undefined;
    }

    export() {
        return {
            id: this.id,
            name: this.name,
        }
    }
}

export class TourImage {
    constructor(data = {}) {
        this.url = data.fileUri || data.fileUrl || undefined;
        this.name = data.fileName || data.filename || undefined;
        this.order = data.order || 0;
    }

    export() {
        return {
            fileUri: this.url,
            filename: this.name,
        }
    }
}

export class TripItinerary {
    constructor(data = {}) {
        if (typeof data === 'string') {
            try {
                this.setData(JSON.parse(data));
            } catch (error) {
                this.setData({});
            }
        }
    }

    setData(data = {}) {
        this.id = data.id;
        this.title = data.title || undefined;
        this.content = data.content || undefined;
    }

    export() {
        const data = {
            id: this.id,
            title: this.title && this.title.trimLeft(),
            content: this.content && this.content.trimLeft(),
        }
        return JSON.stringify(data);
    }
}

export class TourChecklist {
    constructor(data = {}) {
        if (typeof data === 'string') {
            try {
                this.setData(JSON.parse(data));
            } catch (error) {
                this.setData({});
            }
        }
    }

    setData(data = {}) {
        this.id = data.id;
        this.title = data.title || undefined;
        this.content = data.content || []; // array of strings
    }

    export() {
        const data = {
            id: this.id,
            title: this.title && this.title.trimLeft(),
            content: this.content && this.content.map(item => item && item.trimLeft()),
        }
        return JSON.stringify(data);
    }
}

export class TourLine {
    constructor(data = {}) {
        this.setData(data);
    }

    setData(data = {}) {
        this.id = data.id;
        this.tourId = data.tourId;
        this.departureDate = this.getDate(data.departureDate);
        this.seats = data.seats || 0;
        this.soldQuantity = data.soldQuantity || 0;
        this.isEnabled = data.isEnabled !== undefined ? data.isEnabled : true;
        this.tickets = []
    }

    getDate(dateString) {
        return getMomentDate(dateString)
    }

    export() {
        return {
            id: this.id,
            tourId: this.tourId,
            departureDate: this.departureDate && this.departureDate.toISOString(),
            seats: this.seats,
            currency: this.currency,
            isEnabled: this.isEnabled,
            tickets: this.tickets
        }
    }
}

export class TourLineBulk extends TourLine {
    constructor(data = {}) {
        super(data);
        this.setData(data);
    }

    setData(data = {}) {
        super.setData.apply(this, data);
        this.fromDate = this.getDate(data.fromDate);
        this.toDate = this.getDate(data.toDate);
        this.step = data.step || 0;
    }

    export() {
        const tourLine = super.export();
        return {
            tourId: tourLine.tourId,
            seats: tourLine.seats,
            fromDate: this.fromDate && this.fromDate.toISOString(),
            toDate: this.toDate && this.toDate.toISOString(),
            step: this.step,
        }
    }
}

export class TourTicket extends BaseModel {
    constructor(data = {}, isUpdate = false, isCreate = false) {
        super(data, isUpdate);
        this.setData(data, isUpdate)
    }

    initExtraInfos() {
        return [
            { title: 'Mô tả', content: '' },
            { title: 'Bao gồm', content: '' },
            { title: 'Điều khoản', content: '' },
            { title: 'Chính sách hoàn huỷ', content: '' },
            { title: 'Hướng dẫn sử dụng', content: '' }
        ]
    }

    setData(data = this.__data__, isUpdate) {
        this.id = data.id;
        this.tourId = data.tourId || undefined;
        this.name = isUpdate ? data.name : this.translate.name || undefined;
        this.description = isUpdate ? data.description : this.translate.description || undefined;
        this.code = data.code || undefined;
        this.property = new Property(data.property || {})
        this.objectType = new ObjectType(data.objectType || {})
        this.objectTypePrice = (data.objectTypePrice || []).map(item => new ObjectType(item))
        this.soldQuantity = data.soldQuantity || 0;
        this.originalPrice = data.originalPrice || 0;
        this.salePrice = data.salePrice || undefined;
        this.createdDate = data.createdDate || undefined
        this.isAvailable = typeof data.isAvailable === 'boolean' ? data.isAvailable : true;
        this.tourTicketItems = data.tourTicketItems || [];
        this.multiple = data.multiple || 1;
        this.isDefault = true;
        this.rateCodeId = data.rateCodeId || undefined;
        this.rateCode = data.rateCode || undefined;
        this.properties = (data.properties || []).map(item => (item.id || item));
        this.propertyToUse = data.properties || [];
        this.minQuantity = data.minQuantity || 1;
        this.maxQuantity = data.maxQuantity || 0;
        this.surchargeCategoryIds = data.surchargeCategoryIds || undefined;
        this.isEnableListing = data.isEnableListing || false;
        this.tourTicketProductItems = data.tourTicketProductItems || [];
        this.amentity = (data.amentity || []).map(item => (item.id || item));
        this.extraInfos = isUpdate ? data.extraInfos : this.translate.extraInfos || this.initExtraInfos();
        this.targetLanguage = data.targetLanguage ? data.targetLanguage : [];
    }

    export(hasTranslate = false) {
        const result = super.export({
            id: this.id,
            tourId: this.tourId,
            name: this.name,
            description: this.description,
            propertyId: this.property && this.property.id,
            objectTypePrice: this.objectTypePrice.map(item => item.export(hasTranslate)),
            isAvailable: this.isAvailable,
            code: this.code,
            multiple: Number(this.multiple) || 1,
            isDefault: this.isDefault,
            rateCodeId: this.rateCodeId,
            rateCode: this.rateCode,
            propertyIds: this.properties,
            amentityIds: this.amentity.map(e => e.amentityId),
            extraInfos: this.extraInfos
        });
        if (hasTranslate) result.translate = () => {
            return {
                id: this.translate.id,
                tourTicketId: this.translate.tourTicketId || this.id,
                name: this.name,
                description: this.description,
                code: this.code,
                languageCode: this.languageCode,
                propertyId: this.property && this.property.id,
                extraInfos: this.extraInfos
            }
        }
        return result;
    }

}
